import Network from '@/services/network';

export default function handleProjects() {
    const network = new Network;

    const fetchBusinesses = (query) => {
        return network.api('get', '/business' + query);
    }

    const fetchParties = (query) => {
        return network.api('get', '/contact-profile-names' + query);
    }

    const fetchRoles = (query) => {
        return network.api('get', '/roles' + query);
    }

    const createNewProject = (query, data) => {
        return network.api('post', `/procurement/project${query}`, data);
    }

    const fetchProjectList = (query) => {
        return network.api('get', '/procurement/project' + query);
    }

    const fetchProjectTrackerList = (query) => {
        return network.api('get', '/procurement/project/projet-tracker-list' + query);
    }

    const fetchProjects = (query) => {
        return network.api('get', '/procurement/project/get' + query);
    }
    const updateProjectStatus = (id, query, data) => {
        return network.api('patch', '/procurement/project/status-update/' + id + query, data);
    }
    const fetchProjectForm = (id, query) => {
        return network.api('get', `/procurement/project/${id}/edit${query}`);
    }

    const createProjectAccountGroup = (query, data) => {
        return network.api('post', '/procurement/project/account/group' + query, data);
    }

    const createProjectAccount = (query, data) => {
        return network.api('post', '/procurement/project/account' + query, data);
    }

    const updateProjectAccountGroup = (id, query, data) => {
        return network.api('patch', '/procurement/project/account/group/' + id + query, data);
    }

    const updateProjectAccount = (id, query, data) => {
        return network.api('patch', '/procurement/project/account/' + id + query, data);
    }

    const fetchProjectAccount = (id, query) => {
        return network.api('get', `/procurement/project/account/${id + query}`);
    }

    const fetchProjectAccountTree = (id, query) => {
        return network.api('get', `/procurement/project/${id}/account${query}`);
    }

    const fetchProjectAccounts = (id, query) => {
        return network.api('get', `/procurement/project/${id}/account/all${query}`);
    }

    const fetchProjectGroups = (id, query) => {
        return network.api('get', `/procurement/project/${id}/account/groups${query}&is_flatten=1`);
    }

    const fetchProjectDonors = (id, query) => {
        return network.api('get', `/procurement/project/${id}/get/donors${query}`);
    }

    const fetchDonorProjectAccounts = (id, query) => {
        return network.api('get', `/procurement/budget/${id}/activities${query}`);
    }

    const fetchProjectActivity = (query) => {
        return network.api('get', `/procurement/budget/project-activities${query}`);
    }

    const fetchDonorBudgets = (id, query) => {
        return network.api('get', `/procurement/budget/donor/${id}/get-budget${query}`);
    }

    const fetchActualCost = (id, query) => {
        return network.api('get', `/procurement/budget/project-account/${id}/cost${query}`);
    }

    const updateProject = (id, query, data) => {
        return network.api('put', `/procurement/project/${id}` + query, data);
    }

    const fetchAccountsAndItemsByProjectId = (id, query) => {
        return network.api('get', `/procurement/project/accounts-and-items-by-project-id/${id}${query}`);
    }

    const fetchProjectAccountsByProjectId = (id, query) => {
        return network.api('get', `/procurement/project/project-accounts-by-project-id/${id}${query}`);
    }

    const fetchProductsByProjectAccountId = (id, query) => {
        return network.api('get', `/procurement/project/products-by-project-account-id/${id}${query}`);
    }

    const fetchProjectsWithSearchPaginate = (query) => {
        return network.api('get', '/procurement/project/list' + query);
    }

    const fetchProjectOverview = (id, query) => {
        return network.api('get', `/procurement/project/register/overview/${id}${query}`);
    }

    const createBeneficiaryStage = (data, query) => {
        return network.api('post', '/procurement/beneficiary-stage'+query, data);
    }

    const getCurrentBeneficiaryStage = (query) => {
        return network.api('get', '/procurement/beneficiary-stage/current' + query);
    }

    const getBeneficiaryStageData = (query) => {
        return network.api('get', '/procurement/beneficiary-stage' + query);
    }

    const getBeneficiaryDashboardOverview = (query) => {
        return network.api('get', '/procurement/beneficiary-overview' + query);
    }

    const getBeneficiaryDashboardRecentActivity = (query) => {
        return network.api('get', '/procurement/beneficiary-recent-activity' + query);
    }
    const getBeneficiaryDashboardList = (query) => {
        return network.api('get', '/procurement/beneficiary-list' + query);
    }

    const createProjectInstallmentSetup = (query, data) => {
        return network.api('post', `/procurement/project-installment-setup${query}`, data);
    }
    const getProjectInstallmentSetupData = (query) => {
        return network.api('get', '/procurement/project-installment-setup' + query);
    }

    const createInstallmentMoneyReceipt = (id, query, data) => {
        return network.api('patch', '/procurement/installments-money-receipts/' + id + query, data);
    }

    const fetchNarrativeReport = (id, query) => {
        return network.api('get', `/procurement/budget/narrative-report/${id}${query}`);
    }

    const fetchProjectActivityGroupTva = (id, query) => {
        return network.api('get', `/procurement/budget/project-activity-group-tva/${id}${query}`);
    }

    const fetchProjectTeams = (id, query) => {
        return network.api('get', `/procurement/project/${id}/get/teams${query}`);
    }

    const fetchTopAndLowAchievements = (id, query) => {
        return network.api('get', `/procurement/budget/top-low-achievements/${id}${query}`);
    }

    const fetchJobRegisterByProject = (id, query) => {
        return network.api('get', `/procurement/project/job-register/${id}${query}`);
    }
    const createJobStage = (data, query) => {
        return network.api('post', '/procurement/project/job-stage'+query, data);
    }
    const fetchJobStageData = (query) => {
        return network.api('get', '/procurement/project/job-stage' + query);
    }
    const fetchProjectActivityLogs = (query) => {
        return network.api('get', '/procurement/project/activity-logs' + query);
    }
    const storeProjectActivityLogs = (data, query) => {
        return network.api('post', '/procurement/project/activity-logs' + query, data);
    }
    const updateProjectActivityLogs = (id, data, query) => {
        return network.api('post', `/procurement/project/activity-logs/${id}` + query, data);
    }
    const fetchJobTrackerOverview = (query) => {
        return network.api('get', '/procurement/project/job-tracker/overview' + query);
    }
    const fetchJobTrackerRecentActivity = (query) => {
        return network.api('get', '/procurement/project/job-tracker/recent-activity' + query);
    }
    const fetchJobTrackerData= (query) => {
        return network.api('get', '/procurement/project/job-tracker' + query);
    }

    const updateProjectAccountCompletion = (id, data, query) => {
        return network.api('put', `/procurement/project/account-completion-update/${id}` + query, data);
    }

    return {
        fetchBusinesses,
        fetchParties,
        fetchRoles,
        createNewProject,
        fetchProjectList,
        fetchProjectTrackerList,
        fetchProjects,
        updateProjectStatus,
        createProjectAccountGroup,
        createProjectAccount,
        updateProjectAccountGroup,
        updateProjectAccount,
        fetchProjectForm,
        fetchProjectAccountTree,
        fetchProjectAccounts,
        fetchProjectAccount,
        fetchProjectGroups,
        updateProject,
        fetchProjectDonors,
        fetchDonorProjectAccounts,
        fetchProjectActivity,
        fetchActualCost,
        fetchDonorBudgets,
        fetchAccountsAndItemsByProjectId,
        fetchProjectAccountsByProjectId,
        fetchProductsByProjectAccountId,
        fetchProjectsWithSearchPaginate,
        fetchProjectOverview,
        createBeneficiaryStage,
        getCurrentBeneficiaryStage,
        getBeneficiaryStageData,
        getBeneficiaryDashboardOverview,
        getBeneficiaryDashboardRecentActivity,
        getBeneficiaryDashboardList,
        createProjectInstallmentSetup,
        getProjectInstallmentSetupData,
        createInstallmentMoneyReceipt,
        fetchNarrativeReport,
        fetchProjectActivityGroupTva,
        fetchJobRegisterByProject,
        createJobStage,
        fetchJobStageData,
        fetchProjectActivityLogs,
        storeProjectActivityLogs,
        updateProjectActivityLogs,
        fetchJobTrackerOverview,
        fetchJobTrackerRecentActivity,
        fetchJobTrackerData,
        updateProjectAccountCompletion,
        fetchProjectTeams,
        fetchTopAndLowAchievements,
    }
}
